<div class="panel-container">
  <h3>Campanhas</h3>

  <div class="panel-container__buttons">
    <p-button label="Incluir campanha" (onClick)="goToNewScreen()"></p-button>
  </div>

  <div class="panel-container__campaigns">
    <p-panel header="Campanhas cadastradas">
      <p-orderList
        [value]="pageCampaigns"
        [dragdrop]="true"
        [stripedRows]="true"
        (onReorder)="onReorder()"
      >
        <ng-template let-campaign pTemplate="item">
          <div class="panel-container__campaigns__campaign">
            <img
              class="panel-container__campaigns__campaign__image"
              [src]="campaign.image"
              [alt]="campaign.title"
            />

            <div class="panel-container__campaigns__campaign__content">
              <h4>{{ campaign.title }}</h4>
              <span>
                {{ campaign.minimumGlampoints }} a
                {{ campaign.maximumGlampoints }} glampoints
              </span>
              <p>{{ campaign.description }}</p>
              <small># copiada: {{ campaign.hashtagCode }}</small>
              <small
                >Passos cadastrados: {{ campaign.steps?.length || 0 }}</small
              >
            </div>

            <div class="panel-container__campaigns__campaign__actions">
              <p-button
                label="Editar"
                [outlined]="true"
                (onClick)="goToEditScreen(campaign)"
              ></p-button>
              <p-button
                label="Excluir"
                [outlined]="true"
                severity="danger"
                (onClick)="deleteSection(campaign)"
              ></p-button>
            </div>
          </div>
        </ng-template>
      </p-orderList>
      <p-confirmDialog></p-confirmDialog>
    </p-panel>
  </div>
</div>
